import { createSelector } from 'reselect';
import { t } from '../../i18n';
import { Selector } from '../rootReducer';
import * as videoInfoSelectors from '../videoInfo/selectors';
import { PersonalVideoPurpose } from '../videoInfo/types';
import { IVideoText } from './types';

const OpeningTextKeyByVideoPurpose: Record<PersonalVideoPurpose, string> = {
  [PersonalVideoPurpose.EVENT]:
    'customize-video.text.personal.opening.default-value.event',
  [PersonalVideoPurpose.ANNOUNCEMENT]:
    'customize-video.text.personal.opening.default-value.announcement',
  [PersonalVideoPurpose.MEMORIES]:
    'customize-video.text.personal.opening.default-value.memories',
  [PersonalVideoPurpose.TRAVELS]:
    'customize-video.text.personal.opening.default-value.travels',
  [PersonalVideoPurpose.HIGHLIGHTS]:
    'customize-video.text.personal.opening.default-value.highlights',
  [PersonalVideoPurpose.OTHER]:
    'customize-video.text.personal.opening.default-value.other',
};

const getVideoTextSource: Selector<IVideoText> = (state) =>
  state.videoText as IVideoText;

const getVideoTextForBusiness: Selector<IVideoText> = createSelector(
  getVideoTextSource,
  videoInfoSelectors.getBusinessName,
  ({ openingText, mainMessage, closingText }, businessName) => ({
    openingText:
      openingText ||
      t('customize-video.text.business.opening.default-value', {
        businessName,
      }),
    mainMessage:
      mainMessage || t('customize-video.text.business.main.default-value'),
    closingText:
      closingText || t('customize-video.text.business.closing.default-value'),
  }),
);

const getVideoTextForPersonal: Selector<IVideoText> = createSelector(
  getVideoTextSource,
  videoInfoSelectors.getVideoPurpose,
  ({ openingText, mainMessage, closingText }, videoPurpose) => ({
    openingText: openingText || t(OpeningTextKeyByVideoPurpose[videoPurpose]),
    mainMessage:
      mainMessage || t('customize-video.text.personal.main.default-value'),
    closingText:
      closingText || t('customize-video.text.personal.closing.default-value'),
  }),
);

const getVideoText: Selector<IVideoText> = (state) =>
  videoInfoSelectors.isBusinessFlow(state)
    ? getVideoTextForBusiness(state)
    : getVideoTextForPersonal(state);

const getOpeningText: Selector<string> = createSelector(
  getVideoText,
  (texts) => texts.openingText,
);

export { getVideoTextSource, getVideoText, getOpeningText };
